<!--
@Author: Calvin Green <calvin>
@Date:   2022-02-26T10:25:06+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-03-01T17:34:47+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <b-row>
            <b-col cols="8">
                <div class="card bg-dark">
                    <div v-if="hasMounted">
                        <uploader :autoStart="true" :ref="'doc_uploader'" :options="renderUploadOptions()" class="uploader-example">
                            <uploader-unsupport v-show="false"></uploader-unsupport>
                            <uploader-drop v-show="false" style="background-color:rgb(237 255 239);">
                                <b-row>
                                    <b-col cols="7">
                                        <p style="margin-top: 5px ;margin-bottom: 0;">Drop files here to upload or</p>
                                    </b-col>
                                    <b-col cols="5">
                                        <uploader-btn style="margin-bottom: 0;">Select file</uploader-btn>
                                    </b-col>
                                </b-row>
                            </uploader-drop>
                            <uploader-list></uploader-list>
                        </uploader>
                    </div>
                    <annotate-pdf
                    v-if="b64 != null && show_document"
                    :sign_mode="false"
                    @progress="setProgress"
                    @saveSignedPDF="handleSavePDF"
                    :base64="b64"/>
                    <b-alert v-else show>Waiting for document data</b-alert>
                </div>
            </b-col>

            <b-col cols="4">
                <b-card>
                    <b-button size="lg" @click="$bvModal.show('notesModal');" variant="outline-success">
                        <i class="fas fa-comment"></i>
                    </b-button>
                    &nbsp;
                    <b-button size="lg" @click="showRequestModal" variant="outline-success">
                        <i class="fas fa-envelope"></i>
                    </b-button>
                </b-card>

                <b-card title="SOP Info">
                    <div v-if="revision_data != null">
                        <p>
                            <strong>SOP Code:</strong>&nbsp;
                            {{revision_data.client_sop_code}}
                        </p>
                        <p>
                            <strong>SOP Group:</strong>&nbsp;
                            --
                        </p>
                        <p>
                            <strong>SOP Name:</strong>&nbsp;
                            {{revision_data.client_sop_name}}
                        </p>
                        <p>
                            <strong>Revision No:</strong>&nbsp;
                            {{revision_data.client_revision_no}}
                        </p>
                        <p>
                            <strong>Date Released:</strong>&nbsp;
                            {{revision_data.effective_date}}
                        </p>
                    </div>
                </b-card>
                <!-- ************ -->
                <b-card title="Notes">

                </b-card>
                <!-- ************ -->
                <b-card v-if="is_actionable_view">
                    <b-row>
                        <b-col cols="12">
                            <b-button :disabled="scroll_progress > 90 ? false : true" variant="primary" size="lg" @click="readDoc" >
                                Read</b-button>
                            &nbsp;
                            <b-button variant="danger" size="lg" @click="flagDoc">
                                Flag</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-modal hide-footer title="Comment" id="notesModal">
            <div class="modal-body">
                <b-form>
                    <b-form-group class="mb-4" label="Comment: " label-for="comment" label-cols-sm="3">
                        <b-form-input
                            id="comment"
                            type="text"
                            v-model="new_comment_text"
                        ></b-form-input>
                    </b-form-group>
                </b-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary">Save</button>
                <button type="button" class="btn btn-secondary">Close</button>
            </div>
        </b-modal>
        <RequestModal
        v-if="show_request_modal"
        :client_revision_id="revision_data.client_revision_id"/>
    </div>
</template>

<script>
import pdfMixin from '@/mixins/pdfMixin.js'
import RequestModal from './requestUnauthorisedModal.vue'
import Swal from 'sweetalert2'
import Uploader from 'simple-uploader.js'
import _ from 'lodash';
import { sopState, sopMethods, layoutMethods} from '@/state/helpers.js'
export default {
    mixins: [ pdfMixin ],
    data:() => ({
        is_uploading: false,
        b64: null,
        show_document: null,
        revision_data: null,
        scroll_progress: 0,
        hasMounted: false,
        new_comment_text: '',

        show_request_modal: false,
    }),
    components:{
        RequestModal,
    },
    props:{
        //* show the 'Read' and 'Flag' buttons if true
        is_actionable_view:{
            default: true
        }
    },
    computed:{
        ...sopState,
        sop_revisions(){
            if(this.sop_data != null){
                return this.sop_data.client_revisions;
            }
            else{
                return [];
            }
        },
    },
    methods:{
        ...layoutMethods,
        ...sopMethods,
        handleSavePDF(blob){
            //* Get uploader component
            const uploaderInstance = this.$refs['doc_uploader'];
            const upload = uploaderInstance.uploader;
            this.is_uploading = true;

            //* create file object
            let file = new File([blob], 'sop_blob');
            upload.addFile(file);
            this.$nextTick(()=>{
                upload.upload();
            })
        },
        processUpload(file){
            //* Uploader event method
            console.log(this.revision_data)
            let params = {
                client_revision_id: this.revision_data.client_revision_id,
            }
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/clientdocadmin/uploadsignedsop',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:params,
                testChunks: false,
                fileParameterName: 'signed_sop', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile) {
                console.log('fileComplete')
            });
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                console.log('fileAdded', file);
            });

            this.$nextTick(()=>{
                uploader.addFile(file);
                this.$nextTick(()=>{
                    uploader.upload();
                })
            });
        },
        renderUploadOptions() {
            console.log('Rev data -> ',this.revision_data)
            console.log('ID -> ', this.revision_data.client_revision_id)
            let params = {
                client_revision_id: this.revision_data.client_revision_id,
            }
            var storage = window.localStorage;
            var AUTH_TOKEN = storage.getItem('x_token');
            var url = process.env.VUE_APP_API_BASEURL + 'api/clientdocadmin/uploadsignedsop';
            var options = {
                target: url,
                query: params,
                headers: {
                    'Access-Control-Allow-Credentials': true,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                testChunks: false,
                fileParameterName: 'signed_sop', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
            }
            return options;
        },
        findPublishedRevision(){
            let index = _.findIndex(this.sop_revisions, {published: 1});
            if(index != -1){
                this.selectRevision(index);
            }
            else{
                this.$nextTick(()=>{
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'This document has not been published yet!',
                    })
                    this.$emit('back');
                })
            }
        },
        selectRevision(index){
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;
            
            this.hasMounted = true;

            console.log('DDEBUG', this.revision_data)

            //Load pdf b64 of latest revision
            this.b64 = null;
            window.axios({
                url: 'api/clientdocadmin/b64preview/' + this.revision_data.client_revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then( async (response) =>{
                const response_data = response.data;
                //* process the pdf using the helper method from pdfMixin.js
                this.b64 = await this.processPdfBlob(response_data);
                this.show_document = true;
            })



            //this.getPreviewB64(this.revision_data.client_revision_id)
            //.then( data => {
            //    this.b64 = data;
            //    this.show_document = true;
            //    //if(data.pdf_64 != undefined){
            //    //    this.b64 = data.pdf_64;
            //    //    this.show_document = true;
            //    //}
            //})
        },
        setProgress(progress){
            if(progress > this.scroll_progress){
                this.scroll_progress = progress;
            }
        },
        flagDoc(){
            let params = {
                "actionable_id": this.action_id,
                "complete":false,
                "flagged":true,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'red',
                    icon: 'error',
                    title:'Flagged document.',
                    customClass: {     popup: 'warning-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.loadNotifications();
            })
        },
        readDoc(){
            let params = {
                "actionable_id": this.action_id,
                "complete":true,
                "flagged":false,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Marked as read.',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.loadNotifications();
            })
        },



        //* modal stuff **/
        showRequestModal(){
            this.show_request_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('requestsModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'requestsModal'){
                        this.show_request_modal = false;
                    }
                })
            })

        }
    },
    mounted(){
        // Find a revision that has a published flag
        this.findPublishedRevision();
    },

}
</script>

<style>
/*canvas{
    width: 100% !important;
}
.canvas-container{
    width: 100% !important;
}*/
</style>
